import {onMounted, onUnmounted, ref} from "ui.vue3";
import ActivePointSectionComponent from "./ActivePointSectionComponent";
import ActivePointSkeletonComponent from "./ActivePointSkeletonComponent";
import {getDomainFromUrl} from "../lib/getDomainFromUrl";

export default {
  name: 'ActivePointComponent',
  components: {
    ActivePointSectionComponent,
    ActivePointSkeletonComponent
  },
  props: ['point'],
  emits: ['close'],

  setup(props) {

    const data = props.point?.raw && typeof props.point.raw === 'object' ? props.point.raw : {};

    const title = data?.name;

    const isDistributor = !!data?.is_distributor;

    const showAchievement = !data?.is_warehouse;

    const addressLines = [];
    if (data.address) {
      addressLines.push({
        text: data.address,
        isTitle: true,
      });
    }
    if (data.site) {
      const domain = getDomainFromUrl(data.site);
      addressLines.push({
        text: 'Website',
        value: domain ? domain : data.site,
        link: data.site,
      });
    }
    if (data.mail) {
      addressLines.push({
        text: 'Mail',
        value: data.mail,
        link: `mailto:${data.mail}`,
      });
    }
    if (data.phone) {
      addressLines.push({
        text: 'Phone Number',
        value: data.phone,
        link: `tel:${data.phone}`,
      });
    }

    const btn = {
      text: 'Set a route',
      link: `https://www.google.com/maps?daddr=${data.latitude},${data.longitude}`,
    };

    const achievementsTitle = 'Find gear for:';

    const isLoading = ref(true);
    let loadingTimeout = null;

    onMounted(() => {
      loadingTimeout = setTimeout(() => {
        isLoading.value = false;
        loadingTimeout = null;
      }, 350);
    });

    onUnmounted(() => {
      if (loadingTimeout) {
        clearTimeout(loadingTimeout);
        loadingTimeout = null;
      }
    });

    return {
      title,
      addressLines,
      isDistributor,
      showAchievement,
      btn,
      achievementsTitle,
      isLoading,
    };
  },
  template: `
    <div class="partners-map-point">
      <button class="partners-map-point__x" @click="$emit('close')">
        <img src="/local/templates/new_site_v2/images/parthners_map/close_modal.svg" alt="">
      </button>
      <ActivePointSkeletonComponent v-if="isLoading" />
      <div v-else class="partners-map-point__content">
        <div v-if="title" class="partners-map-point__title">
          {{title}}
        </div>
        <div v-if="isDistributor" class="partners-map-point__subtitle">Distributor</div>
        <div v-if="point.achievements && point.achievements.length && showAchievement" class="partners-map-point__achievements">
          <div class="partners-map-point__achievements-title">
            {{achievementsTitle}}
          </div>
          <div class="partners-map-point__achievements-list">
            <img v-for="item in point.achievements" :src="item" alt="">
          </div>
        </div>
        <div v-else class="partners-map-point__achievements">
          <div class="partners-map-point__achievements-title partners-map-point__achievements-warehouse">Warehouse</div>
        </div>
        <ActivePointSectionComponent :lines="addressLines" />
        <a v-if="btn" :href="btn.link" target="_blank" class="partners-map-point__btn">
          {{btn.text}}
        </a>
      </div>
    </div>
  `,
}
